interface ConfigData {
  REACT_APP_BASE_API: string;
  REACT_APP_SHOW_VCONSOLE: boolean;
}
const env = process.env || ({} as ConfigData);
const config = {
  firebaseConfig: {
    apiKey: "AIzaSyBQFKo57cnqAC6K-K3KToG8TCEPoLzaGpw",
    authDomain: "loganalysis.firebaseapp.com",
    databaseURL: "https://loganalysis.firebaseio.com",
    projectId: "loganalysis",
    storageBucket: "loganalysis.appspot.com",
    messagingSenderId: "968987918320",
    appId: "1:968987918320:web:99aa68513911217e79a735",
    measurementId: "G-N871J1CRDK",
  },
  vconsole: {
    enabled: env.REACT_APP_SHOW_VCONSOLE === "true" ? true : false,
  },
  baseUrl: env.REACT_APP_BASE_API,
};

export default config;
